<h3 mat-dialog-title class="dialog-title">How you want to add travelers?<button [mat-dialog-close]="" color="primary" mat-icon-button><mat-icon>close</mat-icon></button></h3>
<p>Note : You can use "Choose from My Travelers" Option after Login.</p>
<section class="travell_dialog" [mat-dialog-close]>
    <div class="wrapper">
        <div class="inner_wrapper">
            <div class="dot_circle" (click)="onManual()" (click)="hide()">
                <img src="../../../../../assets/svgIcon/Vector.svg" alt="Add traveller manually" class="img-fluid" >
            </div>
            <p>Add traveller manually</p>
        </div>
        <div class="inner_wrapper disabled">
            <div class="dot_circle">
                <img src="../../../../../assets/svgIcon/trolley.svg" alt="Choose from my travellers" class="img-fluid">
            </div>
            <p>Choose from my travellers</p>
        </div>
    </div>
</section>


